import type { TechniqueFilterValue } from '@features/customization-technique/utils/technique-filter';

import { useState, useCallback } from 'react';

import { ALL_TECHNIQUES } from '@features/customization-technique/utils/technique-filter';

/** Shared by the workshop plan and the session list: the key name predates the session list, kept to keep choices. */
const STORAGE_KEY = 'workshop-plan-technique';

const readStorage = (): TechniqueFilterValue => {
  try {
    const stored = Number(localStorage.getItem(STORAGE_KEY));
    return Number.isInteger(stored) && stored > 0 ? stored : ALL_TECHNIQUES;
  } catch {
    return ALL_TECHNIQUES;
  }
};

/**
 * Technique filter remembered on the workstation and shared by the workshop screens: a station usually runs one
 * technique, so choosing it on the plan also filters the session list.
 */
export const useTechniqueFilter = () => {
  const [filter, setFilterState] = useState<TechniqueFilterValue>(readStorage);

  const setFilter = useCallback((next: TechniqueFilterValue) => {
    setFilterState(next);
    try {
      if (next === ALL_TECHNIQUES) {
        localStorage.removeItem(STORAGE_KEY);
      } else {
        localStorage.setItem(STORAGE_KEY, String(next));
      }
    } catch {
      // Storage unavailable (private mode): the choice only lasts for this page.
    }
  }, []);

  return [filter, setFilter] as const;
};
